import { render, staticRenderFns } from "./Shapes.vue?vue&type=template&id=677dead9&scoped=true"
import script from "./Shapes.vue?vue&type=script&lang=js"
export * from "./Shapes.vue?vue&type=script&lang=js"
import style0 from "./Shapes.vue?vue&type=style&index=0&id=677dead9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677dead9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('677dead9')) {
      api.createRecord('677dead9', component.options)
    } else {
      api.reload('677dead9', component.options)
    }
    module.hot.accept("./Shapes.vue?vue&type=template&id=677dead9&scoped=true", function () {
      api.rerender('677dead9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/svg-editor/Shapes.vue"
export default component.exports